// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P2GR","delete":"styles_delete__399pu","update":"styles_update__PP01J","add":"styles_add__3l7-X"};